function Redo() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18.054 7.252l-2.296-2.296a.75.75 0 0 1 1.06-1.06l2.83 2.828a1.75 1.75 0 0 1 0 2.475l-2.832 2.831a.75.75 0 0 1-1.06-1.06l2.219-2.22H8a4.25 4.25 0 0 0 0 8.5h4a.75.75 0 0 1 0 1.5H8a5.75 5.75 0 0 1 0-11.5h10c.018 0 .036 0 .054.002z"
        ></path>
      </svg>
    )
  }
  
  export default Redo
  